import _ from 'underscore';
import { LegacyQuickFilterStorage } from './legacy-quick-filter-storage';
import { EditableFilterStorage } from './editable-filter-storage';
import { EditableFilterPermanentStorage } from './editable-filter-permanent-storage';
import { SavedFilterStorage } from './saved-filter-storage';
import { RecentFilterPermanentStorage } from './recent-filter-storage';
import { QuickFilterStorage } from './quick-filter-storage';
import { QuickFilterPermanentStorage } from './quick-filter-permanent-storage';
import { WaterfallFilterPermanentStorage } from './waterfall-filter-permanent-storage';
import { QuickFilterSessionStorage } from './quick-filter-session-storage';

const storageTypeMapping = {
  quickFilter: QuickFilterStorage,
  editableFilter: EditableFilterStorage,
  editableFilterPermanent: EditableFilterPermanentStorage,
  savedFilter: SavedFilterStorage,
  recentFilter: RecentFilterPermanentStorage,
  legacyQuickFilter: LegacyQuickFilterStorage,
  permanentQuickFilter: QuickFilterPermanentStorage,
  permanentWaterfallFilter: WaterfallFilterPermanentStorage,
  sessionQuickFilter: QuickFilterSessionStorage,
};

export class FilterStorageFactory {
  /**
   * Create wrapper of session and preference storage for storing filters
   * @param {Object} preferenceStoreFactory - A method to create an instance
   * of component/bingads-grid/service/grid-preferences
   * @param {Object} sessionStore - A instance of component/js-data-storage/session-storage
   * @param {Object} getLegacySaved - Whether to save filter through UI server
   * to legacy storage
   * @param {Object} featureName - Name of feature
   * @param {Number} maxSavedFilterLimit - Limit to impose on number of saved filters
   * @param {Boolean} parseIdAsInt - Flag indicating whether or not ids in
   * filter queries should be parsed as ints upon deserialization
   */
  constructor({
    preferenceStoreFactory,
    sessionStore,
    getLegacySaved,
    featureName,
    maxSavedFilterLimit,
    parseIdAsInt,
    preferenceService,
  }) {
    this.preferenceStoreFactory = preferenceStoreFactory;
    this.sessionStore = sessionStore;
    this.getLegacySaved = getLegacySaved;
    this.featureName = featureName;
    this.maxSavedFilterLimit = maxSavedFilterLimit;
    this.parseIdAsInt = parseIdAsInt;
    this.preferenceService = preferenceService;
  }

  /**
   *
   * @param {('quickFilter'|'editableFilter'|'savedFilter')}  type - Storage type
   * @param {Object} options - Options for creating storage instance
   * @param {Object} options.filterEntityOptions - Options to create FilterEntity,
   * contains entity schema
   * @param {string} [options.resourceId] - Resource Id
   * @param {string} [options.entryId] - Entry Id
   * @param {Boolean} [options.newCampaignsGridFilterEnabled] --
   *  Indicates whether campaigns grid is using filter-service (used for waterfall filters)
   * @return {Object} An instance of filter storage object of specific type
   */
  create(type, options = {}) {
    let Storage = storageTypeMapping[type];
    if (type === 'editableFilter' && this.preferenceService &&
     !_.isEmpty(this.preferenceService)) {
      Storage = EditableFilterPermanentStorage;
    }
    if (type === 'quickFilter' && this.preferenceService &&
    !_.isEmpty(this.preferenceService)) {
      Storage = QuickFilterPermanentStorage;
    }
    return new (Storage)(_.extend(options || {}, {
      preferenceStoreFactory: this.preferenceStoreFactory,
      sessionStore: this.sessionStore,
      getLegacySaved: this.getLegacySaved,
      featureName: options.featureName || this.featureName,
      maxSavedFilterLimit: this.maxSavedFilterLimit,
      parseIdAsInt: this.parseIdAsInt,
      preferenceService: this.preferenceService,
    }));
  }
}
